import React, { useContext, useRef } from 'react';
import * as Sentry from '@sentry/browser';
import { PropTypes } from 'prop-types';

import ChatMessage from '../../Model/ChatMessage';
import ChatContext from '../../context/ChatContext';
import useToast from '../../hooks/useToast';
import ConfirmDialog from '../ConfirmDialog';
import texts from './texts.json';

const UnflagMessageModal = ({ isOpen, onClose, message }) => {
  const { authUser } = useContext(ChatContext);
  const { showToast } = useToast();
  const isSubmittingRef = useRef(false);

  const handleConfirm = async () => {
    if (isSubmittingRef.current) {
      return;
    }
    isSubmittingRef.current = true;
    try {
      await message.unflag(authUser.id);
      showToast(texts.success);
      onClose();
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          messageId: message.id,
          coachId: authUser?.id,
        },
      });
      showToast(texts.error, { error: true });
      isSubmittingRef.current = false;
    }
  };

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onConfirm={handleConfirm}
      onCancel={onClose}
      dialogTexts={{
        title: texts.title,
        content: texts.content,
        confirm: texts.confirm,
        cancel: texts.cancel,
      }}
    />
  );
};

UnflagMessageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.instanceOf(ChatMessage).isRequired,
};

export default UnflagMessageModal;
